// Зеркало backend-monorepo/libs/types/src/payment/enums/payment-transaction-status.enum.ts
export enum PaymentTransactionStatusEnum {
  CREATED = 0,
  PENDING = 1,
  COMPLETE = 2,
  REJECTED = 3,
}

export const PAYMENT_TRANSACTION_STATUS_LABELS: Record<number, string> = {
  [PaymentTransactionStatusEnum.CREATED]: 'Создана',
  [PaymentTransactionStatusEnum.PENDING]: 'В обработке',
  [PaymentTransactionStatusEnum.COMPLETE]: 'Сделка успешна',
  [PaymentTransactionStatusEnum.REJECTED]: 'Отклонена',
};
